// extracted by mini-css-extract-plugin
export var chip = "_3i-0";
export var filterDropdown = "_3i-5";
export var filterItem = "_3i-6";
export var icon = "_3i-1";
export var removeButton = "_3i-3";
export var removeIcon = "_3i-4";
export var separator = "_3i-2";